import { icons } from "~/ui";

type UploadedStateProps = {
  fileName: string;
  onClear: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const UploadedState = ({ fileName, onClear }: UploadedStateProps) => (
  <div className="absolute flex flex-col items-center justify-center gap-2">
    <span className="rounded-full bg-green-100 p-1">
      <icons.solid.CheckCircleIcon className="size-5 text-green-400" />
    </span>

    <span className="px-4 text-center text-neutral-800">{fileName}</span>

    <button
      type="button"
      onClick={onClear}
      className="flex items-center gap-1 text-sm text-neutral-500 hover:underline"
    >
      <icons.outline.TrashIcon className="size-4" />
      Clear upload
    </button>
  </div>
);
